import React, { createRef, useEffect } from "react";

import { IStatus } from "shared/types";
import { copy } from "shared/assets";
import { getStatus } from "shared/styles/defaults";
import { slideInFromBottom } from "shared/styles/constants";

import {
  StyledMessage,
  StyledDismissContainer,
  StyledDismissButton,
  StyledMessageProps,
  StyledContent,
  StyledIcon,
} from "./styles";

export interface MessageProps extends StyledMessageProps {
  message?: string;
  showDismiss?: boolean;
  onDismiss?: () => void;
  scrollOnMount?: boolean;
  showIcon?: boolean;
  dataTestid?: string;
}

export const Message: React.FC<MessageProps> = ({
  status = IStatus.default,
  showDismiss = false,
  showIcon = true,
  onDismiss,
  message,
  scrollOnMount,
  children,
  dataTestid,
  ...rest
}) => {
  const { icon } = getStatus(status);
  const scrollRef = createRef<HTMLDivElement>();

  useEffect(() => {
    if (!scrollOnMount) return;

    scrollRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [scrollOnMount, scrollRef]);

  return (
    <StyledMessage
      ref={scrollRef}
      status={status}
      {...slideInFromBottom}
      {...rest}
      data-testid={dataTestid || `${status}_message`}
    >
      <StyledContent size="xs" spaceDirection="horizontal" flexWrap="nowrap">
        {showIcon && icon && (
          <StyledIcon
            size="xl"
            as={icon}
            color={getStatus(status).iconColor || "currentColor"}
          />
        )}
        <div>
          {message}
          {children}
        </div>
      </StyledContent>
      {showDismiss && onDismiss && (
        <StyledDismissContainer>
          <StyledDismissButton type="button" onClick={onDismiss}>
            {copy.message.hide}
          </StyledDismissButton>
        </StyledDismissContainer>
      )}
    </StyledMessage>
  );
};
